"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('showHideContactPicker')(function showHideContactPicker(recipientWell, isShown) {
    recipientWell.shouldShowContactPicker = isShown;
});
//# sourceMappingURL=showHideContactPicker.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/showHideContactPicker.js
// module id = 2941
// module chunks = 2 3